import React from 'react'
import SettingsMetaData from '../../../../../Components/Hooks/useSettingsMetaData';

function EquipmentCategory() {
    return (
        <SettingsMetaData propertyName={"EquipmentCategory"} viewPropertyName={"Category"} />
      );
}

export default EquipmentCategory
